import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Drawer } from '@material-ui/core'
import { Menu } from '../Menu'

const useStyles = makeStyles((theme) => ({
  drawer: theme.sidebar
}))

export const SideBar = () => {
  const classes = useStyles()

  const [open] = React.useState(true)

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={open}
      classes={{
        paper: classes.drawer
      }}
    >
      <Menu />
    </Drawer>
  )
}
